import React, { useState } from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import { faTrash, faEdit, faPlus } from "@fortawesome/free-solid-svg-icons";
//@ts-ignore cortex
///@ts-ignore cortex
import { trans } from "@cortexglobal/rla-intl";
import {
    IconTextButton,
    Button,
    Loading,
    Table,
    Pagination,
    Modal,
    Row,
    Column
    //@ts-ignore cortex
} from "@cortexglobal/rla-components";

import { EmptyRow } from "../../../components/EmptyRow";
import { WorkflowStateForm } from "../../../forms/WorkflowStateForm";

const PaddedDiv = styled.div`
    padding: 3em;
`;

export const WorkflowStatesTable = ({ items, loaded, workflow }) => {
    //const currentPage = pagination ? pagination.current_page : 1;

    const [deleteEntityModalShowing, setDeleteEntityModalShowing] = useState(
        false
    );
    const [deleteEntityName, setDeleteEntityName] = useState("");
    const [deleteEntityId, setDeleteEntityId] = useState(null);

    const [editEntityModalShowing, setEditEntityModalShowing] = useState(false);
    const [editEntity, setEditEntity] = useState(null);

    return (
        <React.Fragment>
            <Row
                collapse
                style={{
                    marginBottom: 0,
                    display: "flex",
                    alignItems: "flex-end"
                }}
            >
                <Column medium={12} style={{ textAlign: "right" }} collapse>
                    <IconTextButton
                        icon={faPlus}
                        showCircle={false}
                        onClick={() => {}}
                        style={{ paddingRight: "1rem" }}
                    >
                        {trans("Add State")}
                    </IconTextButton>
                </Column>
            </Row>
            <Table>
                <thead>
                    <tr>
                        <th>State Name</th>
                        <th>Super State</th>
                        <th>Special Type</th>
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {!loaded ? (
                        <EmptyRow colSpan={3}>
                            <Loading />
                        </EmptyRow>
                    ) : !items || items.length === 0 ? (
                        <EmptyRow colSpan={3}>
                            {trans("No items found")}
                        </EmptyRow>
                    ) : (
                        items.map(item => {
                            return (
                                <tr>
                                    <td>{item.name}</td>
                                    <td>
                                        {item.super_state
                                            ? item.super_state.name
                                            : "None"}
                                    </td>
                                    <td>
                                        {item.special_type
                                            ? item.special_type_display
                                            : "None"}
                                    </td>
                                    <td>
                                        <IconTextButton
                                            as={Link}
                                            showCircle={false}
                                            expanded={false}
                                            icon={faEdit}
                                            onClick={event => {
                                                setEditEntity(item);
                                                setEditEntityModalShowing(true);
                                            }}
                                        >
                                            {trans("Edit")}
                                        </IconTextButton>
                                        <IconTextButton
                                            type="alert"
                                            showCircle={false}
                                            expanded={false}
                                            icon={faTrash}
                                            onClick={event => {
                                                setDeleteEntityId(item.uuid);
                                                setDeleteEntityModalShowing(
                                                    true
                                                );
                                                setDeleteEntityName(item.name);
                                            }}
                                        >
                                            {trans("Delete")}
                                        </IconTextButton>
                                    </td>
                                </tr>
                            );
                        })
                    )}
                </tbody>
            </Table>

            {deleteEntityModalShowing && (
                <Modal
                    visible={deleteEntityModalShowing}
                    onClose={() => {
                        setDeleteEntityModalShowing(false);
                    }}
                >
                    <PaddedDiv>
                        <h1>
                            {trans("You are about delete state")}:{" "}
                            {deleteEntityName}
                        </h1>

                        <p>{trans("Are you sure you want to proceed?")}</p>
                        <Button
                            type="hollow"
                            style={{ marginRight: "1em" }}
                            onClick={() => {
                                setDeleteEntityModalShowing(false);
                            }}
                        >
                            {trans("Cancel")}
                        </Button>
                        <Button
                            type="alert"
                            onClick={() => {
                                // deleteItem(deleteEntityId).catch(e =>
                                //     setDeleteEntityModalShowing(false)
                                // );
                            }}
                        >
                            {trans("Delete")}
                        </Button>
                    </PaddedDiv>
                </Modal>
            )}

            {editEntityModalShowing && (
                <Modal
                    visible={editEntityModalShowing}
                    onClose={() => {
                        setEditEntityModalShowing(false);
                    }}
                >
                    <WorkflowStateForm
                        submitForm={() => {}}
                        workflow={workflow}
                        item={editEntity}
                    />
                </Modal>
            )}
        </React.Fragment>
    );
};

// interface WorkflowStatesTableProps {
//     items: State[];
//     loaded: boolean;
//     pagination?: any;
//     deleteItem?: (number) => Promise;
//     onPageChange?: (number) => void;
//     onOrderBy?: (string) => void;
//     onPerPageChange?: ({ value: string }) => void;
// }

export default WorkflowStatesTable;
